import { render, staticRenderFns } from "./disconnect.vue?vue&type=template&id=56145ea3&scoped=true&"
import script from "./disconnect.vue?vue&type=script&lang=js&"
export * from "./disconnect.vue?vue&type=script&lang=js&"
import style0 from "./disconnect.vue?vue&type=style&index=0&id=56145ea3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56145ea3",
  null
  
)

export default component.exports